import React from 'react';
import { i18n as TypeOfi18n, I18nextProvider } from '@wix/wix-i18n-config';
import { ContextProvider, type StoreInitialState } from './context/ContextProvider';
import { DEVICE } from './utils/helpers';
import { MobileApp } from './components/MobileApp/MobileApp';
import { DesktopApp } from './components/DesktopApp/DesktopApp';

export const getApp = (initialState: StoreInitialState, i18n: TypeOfi18n, device: string) => (
  <ContextProvider initialState={initialState}>
    <I18nextProvider i18n={i18n}>{device === DEVICE.DESKTOP ? <DesktopApp /> : <MobileApp />}</I18nextProvider>
  </ContextProvider>
);
